export function resolveDatabaseName(
  syntheticPreview?: string,
  syntheticDatabase?: string,
): string {
  if (syntheticPreview === undefined && syntheticDatabase === undefined) {
    return 'heyboss'
  }
  if (
    syntheticPreview !== 'true' ||
    !syntheticDatabase ||
    !/^heyboss_preview_[a-z0-9]{8,32}$/.test(syntheticDatabase)
  ) {
    throw new Error('Invalid synthetic preview database configuration')
  }
  return syntheticDatabase
}

export const DB = resolveDatabaseName(
  process.env.CLOUD_RUN_SYNTHETIC_PREVIEW,
  process.env.CLOUD_RUN_SYNTHETIC_DB,
)
export const C_USERS = 'users'
export const C_PROJECT_USERS = 'project_users'
export const C_SUPABASE_USERS = 'supabase_users'
export const C_TRANSACTIONS = 'transactions'
export const C_USER_COINS = 'user_coins'
export const C_USER_DEVICES = 'user_devices'
export const C_DEDUCTS = 'deducts'
export const C_WORKSPACE_COINS = 'workspace_coins'
export const C_WORKSPACE_COIN_DEDUCTS = 'workspace_coin_deducts'
export const C_TEMPLATES = 'templates'
export const C_PROJECTS = 'projects'
export const C_API_KEYS = 'api_keys'
export const C_PROJECT_CHILDREN = 'project_children'
export const C_DOMAINS = 'domains' // domain
export const C_USER_ASSETS = 'user_assets'
export const C_DOCUMENTS = 'documents'
export const C_USER_EMAIL_LOGS = 'user_email_logs'
export const C_EMAIL_LOGS = 'sent_emails'
export const C_KNOWLEDGE = 'knowledge'
export const C_ONBOARDING_QUESTIONS = 'onboarding_questions'
export const C_USER_ONBOARDING_QUESTIONS = 'user_onboarding_questions'
export const C_MESSAGE_FEEDBACKS = 'message_feedbacks'
export const C_DISSATISFACTION_CASES = 'dissatisfaction_cases'
export const C_API_ERRORS = 'api_errors'
export const C_USER_PRODUCTS = 'user_products'
export const C_GITHUB_APP_INSTALLATIONS = 'github_app_installations'
export const C_USER_PROMPT_FEEDBACKS = 'user_prompt_feedbacks'
export const C_PROJECT_SHARE_LOGS = 'project_share_logs'
export const C_PROJECT_ERROR_LOGS = 'project_error_logs'
export const C_PROJECT_VISIT_LOGS = 'project_visit_logs'
export const C_INVITATION_CODES = 'invitation_codes'
export const C_USER_OFFERS = 'user_offers'
export const C_OFFER_CLAIMS = 'offer_claims'
export const C_OFFER_WAITLIST = 'offer_waitlist'
export const C_API_BASE = 'api_base'
export const C_FEATURE_BASE = 'feature_base'
export const C_SUPER_PROMPT = 'super_prompts'
export const C_TRANSLATED_TEXT = 'translated_text'
export const C_PROJECT_SUPPORTS = 'project_supports'
export const C_PROJECT_SUBSCRIPTIONS = 'project_subscriptions'
export const C_WORKSPACE_SUBSCRIPTIONS = 'workspace_subscriptions'
export const C_SUBSCRIBER_LTV = 'subscriber_ltv'
export const STRIPE_PURCHASE_TYPE_WORKSPACE_SUBSCRIPTION =
  'workspace_subscription'
export const C_MIGRATION_RUNS = 'migration_runs'
export const C_PROJECT_CODING = 'project_coding'
export const C_PROJECT_QUESTIONS = 'project_questions'
export const C_USER_PROJECT_QUESTIONS = 'user_project_questions'
export const C_WORKSPACES = 'workspaces'
export const C_WORKSPACE_MEMBERS = 'workspace_members'
export const C_WORKSPACE_INVITATIONS = 'workspace_invitations'
export const C_WORKSPACE_INVITE_LINKS = 'workspace_invite_links'
export const C_WORKSPACE_OWNERSHIP_TRANSFERS = 'workspace_ownership_transfers'
export const C_WORKSPACE_NOTIFICATIONS = 'workspace_notifications'
export const C_TEMPLATE_USE_CASES = 'template_use_cases'
export const C_GIFT_CARD_SETTINGS = 'gift_card_settings'
export const C_GIFT_CARD_DESIGNS = 'gift_card_designs'

export const LOCALE_LANGUAGE_MAP = {
  'en-US': 'English',
  'zh-CN': 'Simplified Chinese',
}

export const LOCALE_I18N_MAP = {
  'en-US': 'en',
  'zh-CN': 'zh',
}
export const C_STARTER_KITS = 'starter_kits'
export const C_HOMEPAGE_PROMPTS = 'homepage_prompts'
export const C_FEATURES = 'features'
export const C_FEATURE_USERS = 'feature_users'
export const C_FEATURE_HIT_LOGS = 'feature_hit_logs'
export const C_CONFIG = 'config'
export const C_CODING_LOG = 'coding_log'
export const C_CHATTING_LOG = 'chatting_log'
export const C_DISCONNECT_LOGS = 'disconnect_logs'
export const C_CHANGELOG_SOURCES = 'changelog_sources'
export const C_EMAIL_NOTIFICATIONS = 'email_notifications'
export const C_BLACKLIST = 'blacklist'
export const C_REFERRAL_VISITS = 'referral_visits'
export const SERVICE_CONFIG_NAME = 'service_info'

export const CDN_URL = 'https://heyboss.heeyo.ai'

export const BASE_TEMPLATE_URL =
  'https://heyboss.heeyo.ai/templates-javascript-8d3cde.zip'
export const BASE_WORKER_TEMPLATE_URL =
  'https://heyboss.heeyo.ai/templates-worker-543feb.zip'

export const DOMAIN_GATEWAY_IP = '54.86.223.182'

export const APPLICATION_URL = 'service.heyboss.tech'
export const WORKER_APPLICATION_URL = 'service.heyboss.live'

export const LOCALES = ['en', 'zh']
export const DEFAULT_LOCALE = 'en'
export const PROTECTED_PATHS = ['/settings', '/qa', '/admin']

export const USER_DEFAULT_COIN = 0 // 不再赠送注册金币：所有使用都需付费
// export const USER_DEFAULT_FREE_PROJECT_NUM = 1 // NOTE: 注册即送一个免费项目
// export const USER_DEFAULT_FREE_PROJECT_NUM_V3_LAUNCH = 0 // NOTE: 注册时不送，通过特效视频流程后送
export const USER_DEFAULT_FREE_PROJECT_NUM = 0 // 新用户不再有免费项目
export const USER_DEFAULT_FREE_CODING_NUM = 0 // 不再送免费 coding 额度
export const MIN_COIN_FOR_CODING = 20
export const EMAIL_PRICE_PER_RECIPIENT = 0.2
/**
 * @deprecated 改成更通用的 upload files 方法
 */
export const MAX_IMAGE_UPLOAD = 8
/**
 * @deprecated 改成更通用的 upload files 方法，使用 ALLOWED_UPLOAD_ASSETS_FORMATS
 */
export const ALLOWED_IMAGE_FORMATS = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
] as const
/**
 * @deprecated 改成更通用的 upload files 方法
 */
export const ALLOWED_IMAGE_FORMATS_TEXT = 'JPG, JPEG, PNG, WEBP'

export const PDF_FILE_THUMBNAIL_URL =
  'https://heyboss.heeyo.ai/design-system/pdf.svg'

export const ASSISTANT_NAME = 'AI'
export const SCRATCHPAD_FILE_NAME = 'scratchpad.md'
export const PRD_FILE_NAME = 'PRD.md'
export const STATUS_FILE_NAME = 'status.json'
export const SUGGESTIONS_FILE_NAME = 'suggestion.json'
export const APPS_DIR_NAME = 'Features'

export const BACKEND_API_URL =
  process.env.NEXT_PUBLIC_BACKEND_API_URL || 'https://backend.heybossai.com'
export const API_HUB_URL = (
  process.env.API_HUB_API_URL || 'https://api.skillboss.co'
).replace(/\/v1\/?$|\/$/, '')
export const DIRECTUS_URL = 'https://cms.heybossai.com'

export const EMAIL_URL = 'mailto:contact@heyboss.xyz'
export const DISCORD_URL = 'https://discord.gg/U9eM6Vn6g7'
export const X_URL = 'https://x.com/heybossAI'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/heybossai/'
export const YOUTUBE_URL = 'https://www.youtube.com/@heybossai'

export const FEATUREBASE_URL = 'https://heyboss.featurebase.app'
export const ROADMAP_URL = `${FEATUREBASE_URL}/roadmap`
export const CHANGELOG_URL = 'https://heyboss.substack.com/'
export const LEGAL_URL = 'https://legal.heyboss.tech'
export const TERMS_URL = `${LEGAL_URL}/67845cfe76f9675292514b80/`
export const PRIVACY_URL = `${LEGAL_URL}/67845a5e6e6bf5ecd4a3ae47/`
export const ABOUT_URL = `${LEGAL_URL}/678cdd/`
export const AFFILIATE_URL = 'https://affiliates.heybossai.com/signup'
export const MEDIA_KITS_URL = 'https://page.heyboss.tech/0f7f8be2/'

export const PROD_APP_URL = 'https://heyboss.ai'
export const PROD_APP_URL_LIST = [
  'https://heybossai.com',
  'https://heyboss.ai',
  'https://staging.heyboss.xyz', // Staging environment
]
export const HELP_URL = 'https://help.heyboss.ai/en/'
export const HELP_REDIRECT_URL = 'https://help.heyboss.ai/en/'

// IS_PROD: Only heyboss.ai is considered production environment
// Non-prod environments (staging, local) will send data in debug/test mode
export const IS_PROD = process.env.NEXT_PUBLIC_APP_URL === PROD_APP_URL
export const IS_DEV = !IS_PROD

export const MIN_COIN_FOR_GIFT = 1
export const MAX_COIN_FOR_GIFT = 10000

export const EMAIL_BATCH_SIZE = 100

export const MAX_DOCUMENT_COUNT = 3
export const MAX_DOCUMENT_SIZE = 2.5 * 1024 * 1024 // 2.5MB
export const MAX_DOCUMENT_SIZE_TEXT = '2.5MB'
export const MAX_DOCUMENT_TEXT_SIZE = 16384
export const DOCUMENT_CHUNK_SIZE = 8192 // 8KB
export const DOCUMENT_CHUNK_OVERLAP = 512 // 0.5KB
export const DOCUMENT_EMBEDDING_DIMENSION = 1536
export enum EDocumentMIMEType {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  TXT = 'text/plain',
}
export const ALLOWED_DOCUMENT_MIME_TYPES = [
  EDocumentMIMEType.PDF,
  EDocumentMIMEType.DOC,
  EDocumentMIMEType.DOCX,
  EDocumentMIMEType.XLS,
  EDocumentMIMEType.XLSX,
  EDocumentMIMEType.CSV,
  EDocumentMIMEType.TXT,
]

export const SCREENSHOT_WIDTH = 1280
export const SCREENSHOT_HEIGHT = 720

// 用户最大可分享次数
export const MAX_SHARE_COUNT = 2
// 分享一次可获得金币数
export const SHARE_COIN = 0 // 不再赠送分享金币
export const GIFT_CARD_COIN_EXCHANGE_RATE = 20
// Invitation code
export const INVITATION_VERIFIED_COOKIE_NAME = 'invitation_verified'
export const INVITATION_VERIFIED_COOKIE_EXPIRY_TIME = 7 * 24 * 60 * 60 * 1000 // 7 days（毫秒）

export const PENDING_INVITATION_CODE_COOKIE_NAME = 'pending_invitation_code'
export const PENDING_INVITATION_CODE_COOKIE_EXPIRY_TIME = 3600 * 2 // 2 hour expiry(秒)

// 总红包个数(10000)
export const TOTAL_OFFER_COUNT = 10000
// 判断是否为新老用户的时间点，在这里时间之前，都认为是老用户，在这个时间之后，都任务是新用户
// 2025-04-08 09:00:00', 'America/Los_Angeles' pst 时间
// dayjs('2025-04-08 09:00:00', 'America/Los_Angeles')
// export const OFFER_TIME_POINT = '2025-04-08 09:00:00'
export const OFFER_TIME_POINT = '2025-04-08 09:00:00' // 为测试方便，先改成 2024 年，上线前需要改成 2025 年

export const COOKIE_SESSION_KEY = 'session'

export const MAX_PROMPT_LENGTH = 6000

export const CODE_OWNERSHIP_PRICE_PROTOTYPE = 5900 // $59 in cents for Stripe
export const CODE_OWNERSHIP_PRICE_STANDARD = 2999 // $99 in cents for Stripe
export const STRIPE_PURCHASE_TYPE_CODE_OWNERSHIP = 'codeOwnership'
export const AUTO_FIX_ISSUE_TIME_LIMIT = 3

export const REFERRAL_REWARD_PERCENTAGE = 0.2

export const STRIPE_PURCHASE_TYPE_PROJECT_SUBSCRIPTION = 'project_subscription'

export const DEMO_URL = 'https://demo.heyboss.xyz'

// Google Analytics 4 Measurement ID
// Get from environment variable NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID (format: G-XXXXXXXXXX)
// This is the GA4 Measurement ID, NOT the Google Ads Tag ID
// Used for both client-side GA4 tag loading and server-side Measurement Protocol
// Fallback to default GA4 ID if environment variable is not set
export const GOOGLE_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID || 'G-LQY9LVHBJ7'

// Google Ads Tag ID (hardcoded)
// This is the Google Ads conversion tag ID (format: AW-XXXXXXXXXX)
// Used separately from GA4, NOT combined with GA4 tag
export const GOOGLE_ADS_TAG_ID = 'AW-17523810626'

// Google Tag Manager
export const GOOGLE_TAG_MANAGER_ID = 'GTM-K3NPD7VG'

// Social Pixel
export const SOCIAL_PIXEL_ID = '653608027728038'
export const SOCIAL_TEST_EVENT_CODE = 'TEST15502'

// Reddit Pixel
export const REDDIT_PIXEL_ID = 'a2_h30vl3wclaga'

// Google Ads Conversion Tracking Labels
// 在 Google Ads 后台创建转化操作后，将对应的标签填入此处
// 格式：只需要标签部分（如 "AbC123XyZ"），不需要完整的 "AW-17523810626/AbC123XyZ"
// 这些标签在 Google Ads 中配置好后，直接在这里硬编码即可
export const GOOGLE_ADS_CONVERSION_LABELS = {
  // 主要转化：订阅购买（最重要，必须配置）
  // 在 Google Ads 中创建 Purchase 类型的转化操作
  SUBSCRIBE_PURCHASE: '12-nCKep-rYbEMLCgKRB', // Google Ads Purchase 转化标签

  // 次要转化：用户参与度
  SIGNUP: 'bY9oCPqy_rcbEMLCgKRB', // Google Ads Sign-up 转化标签
  LOGIN: '', // 不用于 Google Ads 转化，仅在 GA4 中追踪
  BEGIN_CHECKOUT: 'n1c7CPzbhbgbEMLCgKRB', // Google Ads Begin Checkout 转化标签
  START_CODING: '', // 不用于 Google Ads 转化，仅在 GA4 中追踪
  FINISH_CODING: '', // 不用于 Google Ads 转化，仅在 GA4 中追踪
} as const

// 向后兼容：保持旧的常量名称
// 如果只配置了一个通用转化标签，可以使用环境变量 NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL
export const GOOGLE_ADS_CONVERSION_LABEL =
  GOOGLE_ADS_CONVERSION_LABELS.SUBSCRIBE_PURCHASE ||
  process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL ||
  ''

// GA4 Measurement Protocol (for server-side tracking)
// Use the same GA4 Measurement ID as GOOGLE_MEASUREMENT_ID
// Both client-side and server-side should use the same ID
// This is now redundant since GOOGLE_MEASUREMENT_ID already has the fallback,
// but kept for backward compatibility
export const GA4_MEASUREMENT_ID = GOOGLE_MEASUREMENT_ID
export const GOOGLE_MEASUREMENT_API_SECRET =
  process.env.GOOGLE_MEASUREMENT_API_SECRET || ''

export const MASTER_REFERRAL_CODE = 'BOSSMODE' // from contact@heyboss.xyz

// Loops 邮件列表 ID
export const LOOPS_MAILING_LIST_PAID_USERS = 'cmdbx6jmx288n0i0kdr9x5avk' // Paid Users

export const LOOPS_MAILING_LIST_INTERNAL_USERS = 'cmdaky0p007vp0i20e49wcop1' // internal-users

export const LOOPS_MAILING_LIST_DEFAULT_USERS = 'cmdit5ym90o840iy00ltdht52'

// Blog Pagination Size
export const POSTS_PER_PAGE = 12

export const CATEGORIES = [
  { id: 'Website', label: 'Website' },
  { id: 'Store', label: 'Store' },
  { id: 'Blog', label: 'Blog' },
  { id: 'Community', label: 'Community' },
  { id: 'Portfolio', label: 'Portfolio' },
  { id: 'Apps', label: 'Apps' },
  { id: 'Commerce', label: 'Commerce' },
] as const

export const OPENAI_DOMAIN_KEY = process.env.NEXT_PUBLIC_OPENAI_DOMAIN_KEY || ''
